<template>
  <bg-style :bg="model.background" :mobile-bg="model.mobileBackground" :style="getStyle" class="collapse-widget" :class="{ 'is-mobile': $store.getters.isMobile }">
    <div class="collapse-widget__content">
      <rich-text
        v-if="model.titleVisible"
        v-model="model.title"
        :stroke.sync="model.titleStroke"
        class="collapse-title"
        :editing="editing"
        :disabled="!editing"
        placement="bottom"
      />
      <model-wrapper v-for="(child,index) in model.children" :key="index + 'item'" :model-index="index" :model="child" :parent-model="model" class="mb-2">
        <bg-style :bg="model.bgConfig" class="collapse-widget__item">
          <bg-style :bg="model.bgConfig" class="title-block" @click.native="handleTitleShowContent(child)">
            <rich-text v-model="child.title" class="w-full relative" :editing="editing" :disabled="!editing" @click.native.stop="handleTitleShowContent(child)" />
            <i v-if="child.__visible" class="el-icon-arrow-down ml-5 cursor-pointer arrow" @click.stop="handleArrowShowContent(child)" />
            <i v-else class="el-icon-arrow-right ml-5 cursor-pointer arrow" @click.stop="handleArrowShowContent(child)" />
          </bg-style>
          <el-collapse-transition>
            <div v-show="child.__visible">
              <div class="content-block" :class="{ 'is-horizontal': isHorizontal }">
                <div v-if="child.blockList.length" class="image-list relative mb-5">
                  <div v-for="(block, blockIndex) in child.blockList" :key="blockIndex + 'block'" class="item">
                    <div v-if="block.thumbBackground.backgroundImageShow" class="relative min-h-[60px]" :class="{ 'min-w-[140px]': editing && isHorizontal }">
                      <img :src="block.thumbBackground.backgroundImage" alt="">
                      <cover-block v-if="editing" absolute class="top-0" @click="handleShowThumbUpload(blockIndex)" />
                    </div>
                    <rich-text v-model="block.desc" class="describe" :editing="editing" :disabled="!editing" />
                  </div>
                </div>
                <bg-style v-if="child.descriptionShow" class="w-full" :bg="model.descBackground">
                  <rich-text
                    v-model="child.description"
                    class="descriptions relative"
                    :editing="editing"
                    :disabled="!editing"
                  />
                </bg-style>
              </div>
            </div>
          </el-collapse-transition>
        </bg-style>
      </model-wrapper>
    </div>
  </bg-style>
</template>

<script>
import RichText from '~/components/richText/index.vue'
import ModelWrapper from '~/components/modelWrapper/index.vue'
import { getTextColor, sleep } from '~/utils'
import CoverBlock from '~/components/common/CoverBlock.vue'

export default {
  name: 'CollapseWidget',
  components: {
    CoverBlock,
    ModelWrapper,
    RichText
  },
  props: {
    model: {
      type: Object,
      default() {
        return {}
      },
    },
    editing: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      visible: false,
      currentIndex: -1
    }
  },
  computed: {
    isHorizontal() {
      return this.model.layoutMethod === 'horizontal'
    },
    getStyle() {
      return {
        '--arrow-color': getTextColor(this.model.arrow).color
      }
    }
  },
  methods: {
    handleTitleShowContent(child) {
      if (this.editing) return
      child.__visible = !child.__visible
    },
    async handleShowThumbUpload(index) {
      await sleep(500)
      this.SiteMenu.showImageWithKey(`show-collapse-img-${index}`)
    },
    handleArrowShowContent(child) {
      child.__visible = !child.__visible
    }
  }
}
</script>

<style lang="less">
.collapse-widget {
  padding: 20px;
  &__content {
    max-width: 1040px;
    margin: 0 auto;
    .collapse-title {
      margin-bottom: 40px;
    }
  }
  &__item {
    .title-block {
      min-height: 74px;
      padding: 16px 36px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      line-height: 30px;
      cursor: pointer;
      .arrow {
        color: var(--arrow-color);
        position: relative;
        font-size: 24px;
        font-weight: bold;
      }
    }
    .content-block {
      padding: 0 0 40px 0;
      &.is-horizontal {
        .image-list {
          flex-direction: column;
          .item {
            display: flex;
            align-items: center;
            .describe {
              width: 100%;
            }
          }
        }
      }
      .image-list {
        display: flex;
        flex-wrap: nowrap;
        padding: 0 80px;
        gap: 30px;
        .item {
          flex: 1;
        }
      }
      .collapse-image {
        height: 180px;
        width: 320px;
        flex-shrink: 0;
      }
    }
  }
  &.is-mobile {
    .collapse-widget__item {
      .title-block {
        min-height: 60px;
        padding: 0 12px;
        font-size: 14px;
        line-height: 22px;
      }
      .content-block {
        padding: 0 0 10px 0;
        .image-list {
          padding: 0 10px;
          gap: 10px;
        }
        .descriptions {
          margin-bottom: 12px !important;
          margin-left: 0 !important;
        }
        .collapse-image {
          max-width: 100%;
        }
      }
    }
  }
}
</style>
